import PropTypes from "prop-types";

import Img from "components/atoms/Img";
import Title from "components/atoms/Title";

/** ========== */

const WhyChooseUs = ({ title, data, sectionClassName, note, children }) => {
  return (
    <section className={sectionClassName}>
      <div className="container">
        <div>
          {note && note.length > 0 ? (
            <>
              <Title
                as="h2"
                text={title}
                className="title-h2 mb-4 text-center text-white lg:mb-6"
              />
              <p
                className="mb-10 text-center text-white"
                dangerouslySetInnerHTML={{ __html: note }}
              />
            </>
          ) : (
            <>
              <Title
                as="h2"
                text={title}
                className="title-h2 mb-4 text-center text-white lg:mb-10"
              />
            </>
          )}
          <div className="row justify-center gap-y-6 lg:gap-y-10">
            {data.length > 0 &&
              data.map((item, index) => (
                <div
                  className={`col-12 ${
                    data.length === 4 ? "lg:col-3" : "lg:col-4"
                  }`}
                  key={index}
                >
                  <div className="text-center">
                    <Img
                      src={item.icon.src}
                      alt={item.icon.altText}
                      width={48}
                      height={48}
                      wrapper={{
                        className:
                          "flex items-center justify-center bg-white rounded-[26px] h-20 w-20  mx-auto",
                      }}
                    />
                    <div className="flex justify-center">
                      <Title
                        as="h3"
                        text={item.title}
                        className="mt-6 w-5/6 text-lg font-semibold normal-case text-white"
                      />
                    </div>
                    {item?.description && (
                      <p className="mt-3 !normal-case text-white">
                        {item.description}
                      </p>
                    )}
                  </div>
                </div>
              ))}
          </div>
        </div>
      </div>
      {children}
    </section>
  );
};

export default WhyChooseUs;

WhyChooseUs.propTypes = {
  title: PropTypes.string,
  data: PropTypes.array,
  sectionClassName: PropTypes.string,
};

WhyChooseUs.defaultProps = {
  title: "",
  data: [],
  sectionClassName: "",
};

/** ========== */
